import React, { memo } from 'react';
import './Styles.css';
import AddressSearch from '../CommonFields/AddressSearch';
import PostalFields from '../CommonFields/PostalFields';
import CareOfFields from '../CommonFields/CareOfFields';
import AddressCountrySelector from '../CommonFields/AddressCountrySelector';
import { PresentationMode } from '../../../../Enums/PresentationMode';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import TextInput from '../../../ids/InputElements/TextInput';
import { COUNTRY_CODE_DENMARK, COUNTRY_CODE_GREENLAND, COUNTRY_CODE_SWEDEN } from '../../../../Helpers/AddressHelper';

const StreetAddress = ({ getCommonFields, modalMode, addressState, countryList, setAddressState }) => {
  return (
    <>
      {modalMode === PresentationMode.Add && (
        <AddressSearch addressState={addressState} setAddressState={setAddressState} />
      )}

      <CareOfFields addressState={addressState} setAddressState={setAddressState} modalMode={modalMode} />

      <div className="formatSwitcher-streetAddress-nameContainer">
        <div className="formatSwitcher-streetAddress-name">
          <TextInput label={formatMessage(Messages.addressInfo_streetName)} {...getCommonFields('streetName', true)} />
        </div>
        <div>
          <TextInput
            label={formatMessage(Messages.addressInfo_houseNumber)}
            {...getCommonFields('houseNumber', true)}
          />
        </div>
        <div>
          <TextInput label={formatMessage(Messages.addressInfo_houseLetter)} {...getCommonFields('houseLetter')} />
        </div>
      </div>

      {[COUNTRY_CODE_SWEDEN, COUNTRY_CODE_DENMARK, COUNTRY_CODE_GREENLAND].includes(
        addressState.address.country?.code
      ) && (
        <TextInput
          label={formatMessage(Messages.addressInfo_apartmentNumber)}
          {...getCommonFields('apartmentNumber')}
          cssClasses="formatSwitcher-streetAddress-apartment"
        />
      )}

      <TextInput
        label={formatMessage(Messages.addressInfo_additionalLine)}
        {...getCommonFields('additionalAddress')}
        cssClasses="formatSwitcher-streetAddress-additional"
      />

      <AddressCountrySelector addressState={addressState} countryList={countryList} setAddressState={setAddressState} />
      <PostalFields
        key={addressState.address.postalCode}
        addressState={addressState}
        setAddressState={setAddressState}
        getCommonFields={getCommonFields}
      />
    </>
  );
};

export default memo(StreetAddress);
